import { useState } from 'react';
import type { Finanziamento } from '../../types';

interface FondiPropriFormProps {
  finanziamento?: Finanziamento;
  onSave: (data: Partial<Finanziamento>) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function FondiPropriForm({
  finanziamento,
  onSave,
  onCancel,
  isLoading,
}: FondiPropriFormProps) {
  const [formData, setFormData] = useState({
    nome: finanziamento?.nome || '',
    importo: finanziamento?.importo || '',
    note: finanziamento?.note || '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      tipo: 'fondi_propri',
      nome: formData.nome,
      importo: formData.importo,
      tassoInteresse: '0.0000',
      durataAnni: 0,
      rataMensile: '0.00',
      note: formData.note || null,
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="input-group">
        <label htmlFor="nome" className="input-label">
          Descrizione
        </label>
        <input
          type="text"
          id="nome"
          name="nome"
          value={formData.nome}
          onChange={handleChange}
          className="w-full"
          placeholder="es. Risparmi personali, Donazione genitori"
          required
        />
      </div>

      <div className="input-group">
        <label htmlFor="importo" className="input-label">
          Importo (€)
        </label>
        <input
          type="number"
          id="importo"
          name="importo"
          value={formData.importo}
          onChange={handleChange}
          className="w-full"
          min="0"
          step="100"
          placeholder="50000"
          required
        />
      </div>

      <div className="input-group">
        <label htmlFor="note" className="input-label">
          Note (opzionale)
        </label>
        <textarea
          id="note"
          name="note"
          value={formData.note}
          onChange={handleChange}
          className="w-full"
          rows={2}
          placeholder="es. Liquidazione conto corrente"
        />
      </div>

      <div className="flex gap-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="btn-secondary flex-1"
          disabled={isLoading}
        >
          Annulla
        </button>
        <button
          type="submit"
          className="btn-primary flex-1"
          disabled={isLoading}
        >
          {isLoading
            ? 'Salvataggio...'
            : finanziamento
              ? 'Salva Modifiche'
              : 'Aggiungi Fondi Propri'}
        </button>
      </div>
    </form>
  );
}
